"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var likelihood = ["Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Extremely likely"];

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var questions = screenersImport.expandscreeners([{
  prompt: "This self-assessment takes 5 minutes to complete, and will provide you " + "with a snapshot of your mental fitness alongside global averages. Your responses  " + "are stored securely, confidential between you and your coach, and will never be used " + "to identify you to a third party.",
  options: [],
  intro: true,
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, utils.screeners.PSS4, utils.screeners.ROI_HPQ_3_DAYSLIDE, utils.screeners.ROI_HPQ_3_POINTSLIDE, utils.screeners.ORS, utils.screeners.WHO5, // NPS
{
  prompt: "How likely are you to recommend your company to a friend as a " + "great place to work?",
  extraText: "",
  type: "slider",
  options: likelihood,
  key: "npsWork",
  eval: likelihoodFn,
  batteryId: "survey"
}, // Company support and cohesion
{
  prompt: "In the past week, to what extent have you felt supported by " + "your company?",
  extraText: "",
  type: "slider",
  options: ["Not at all supported", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely supported"],
  key: "companySupport",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, {
  prompt: "In the past week, how united has your team been in trying to " + "reach its goals for performance?",
  extraText: "",
  type: "slider",
  options: ["Not at all united", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely united"],
  key: "cohesion",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, // Sleep
{
  prompt: "Please rate the quality of your sleep over the last week.",
  extraText: "",
  type: "slider",
  options: ["Worst possible sleep", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Best possible sleep"],
  key: "sleepQuality",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, // Demographics
{
  prompt: "What is your gender?",
  type: "multi",
  options: ["Male", "Female", "Other"],
  key: "gender",
  eval: function _eval(n, q) {
    return q.options[n];
  },
  batteryId: "survey"
}, {
  prompt: "What is your age?",
  extraText: "",
  type: "single",
  optional: false,
  key: "age",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, {
  prompt: "Which industry do you work in?",
  extraText: "",
  type: "single",
  optional: false,
  key: "industry",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, {
  prompt: "What is your job title?",
  extraText: "",
  type: "single",
  optional: false,
  key: "jobTitle",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, {
  prompt: "How many hours did you work in the last week?",
  extraText: "",
  type: "single",
  optional: false,
  key: "hoursWorkedLastWeek",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}]);

var analysis = function analysis(answers, numeric) {
  if (!answers) return null;
  var results = {};
  results.scales = {};
  results.humanReadable = {} // semi-colon is needed
  ;
  [utils.screeners.PSS4, utils.screeners.ROI_HPQ_3_DAYSLIDE, utils.screeners.ROI_HPQ_3_POINTSLIDE, utils.screeners.ORS, utils.screeners.WHO5].forEach(function (battery) {
    var batteryResults = screenersImport.extractResults(questions, answers, battery);
    var scales = screenersImport.getScalesByBatteryId(battery);

    if (scales) {
      results.scales = Object.assign(results.scales, scales);
    }

    var batteryHumanReadable = batteryResults.humanReadable;
    delete batteryResults.humanReadable;
    results = Object.assign(results, batteryResults);
    results.humanReadable = Object.assign(results.humanReadable, batteryHumanReadable);
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;

    if (numeric) {
      results[q.key] = answers[i];
    } else {
      results[q.key] = q.eval(answers[i], q);
      results.humanReadable[q.prompt] = q.eval(answers[i], q);
    }
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};